// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lock-screen-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(16px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.lock-screen-container {
  background-color: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 24px;
  padding: 48px;
  width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
}

.lock-avatar-container {
  position: relative;
  width: 96px;
  height: 96px;
  margin-bottom: 24px;
}

.lock-avatar, .lock-avatar-fallback {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid var(--brand-primary);
}

.lock-avatar-fallback {
  background-color: var(--brand-primary);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
  font-weight: 700;
}

.lock-icon-badge {
  position: absolute;
  bottom: -4px;
  right: -4px;
  background-color: var(--bg-tertiary);
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid var(--bg-secondary);
  color: var(--text-muted);
}

.lock-welcome {
  font-size: 24px;
  font-weight: 600;
  color: var(--text-normal);
  margin: 0 0 8px 0;
}

.lock-username {
  font-size: 14px;
  color: var(--text-muted);
  margin: 0 0 32px 0;
}

.lock-form {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.pin-input-wrapper {
  width: 100%;
  position: relative;
  margin-bottom: 16px;
}

.pin-input {
  width: 100%;
  background-color: var(--bg-tertiary);
  border: 2px solid transparent;
  border-radius: 12px;
  padding: 16px;
  font-size: 24px;
  letter-spacing: 8px;
  text-align: center;
  color: var(--text-normal);
  transition: all 0.2s ease;
  font-family: monospace;
}

.pin-input:focus {
  outline: none;
  border-color: var(--brand-primary);
  background-color: var(--bg-primary);
}

.pin-input-wrapper.error .pin-input {
  border-color: #ef4444;
  color: #ef4444;
}

.lock-hint {
  font-size: 13px;
  color: var(--text-muted);
  text-align: center;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/LockScreen/LockScreen.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,qCAAqC;EACrC,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,SAAS;AACX","sourcesContent":[".lock-screen-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  background-color: rgba(0, 0, 0, 0.75);\n  backdrop-filter: blur(16px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.lock-screen-container {\n  background-color: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 24px;\n  padding: 48px;\n  width: 400px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);\n}\n\n.lock-avatar-container {\n  position: relative;\n  width: 96px;\n  height: 96px;\n  margin-bottom: 24px;\n}\n\n.lock-avatar, .lock-avatar-fallback {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 3px solid var(--brand-primary);\n}\n\n.lock-avatar-fallback {\n  background-color: var(--brand-primary);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 36px;\n  font-weight: 700;\n}\n\n.lock-icon-badge {\n  position: absolute;\n  bottom: -4px;\n  right: -4px;\n  background-color: var(--bg-tertiary);\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 2px solid var(--bg-secondary);\n  color: var(--text-muted);\n}\n\n.lock-welcome {\n  font-size: 24px;\n  font-weight: 600;\n  color: var(--text-normal);\n  margin: 0 0 8px 0;\n}\n\n.lock-username {\n  font-size: 14px;\n  color: var(--text-muted);\n  margin: 0 0 32px 0;\n}\n\n.lock-form {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.pin-input-wrapper {\n  width: 100%;\n  position: relative;\n  margin-bottom: 16px;\n}\n\n.pin-input {\n  width: 100%;\n  background-color: var(--bg-tertiary);\n  border: 2px solid transparent;\n  border-radius: 12px;\n  padding: 16px;\n  font-size: 24px;\n  letter-spacing: 8px;\n  text-align: center;\n  color: var(--text-normal);\n  transition: all 0.2s ease;\n  font-family: monospace;\n}\n\n.pin-input:focus {\n  outline: none;\n  border-color: var(--brand-primary);\n  background-color: var(--bg-primary);\n}\n\n.pin-input-wrapper.error .pin-input {\n  border-color: #ef4444;\n  color: #ef4444;\n}\n\n.lock-hint {\n  font-size: 13px;\n  color: var(--text-muted);\n  text-align: center;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
